import React, {createContext} from 'react';

import type {EmojiCursor} from './types';

const CursorContext = createContext<EmojiCursor>({
    rowIndex: -1,
    emojiId: '',
    emoji: undefined,
});

const useCursorContext = () => React.useContext(CursorContext);

export {CursorContext, useCursorContext};
